export default {
  withholdingList: {
    column: {
      docNo: '单据编号',
      accruedCompanyCode: '公司代码',
      accruedCompanyName: '公司名称',
      accruedDepartmentCode: '部门代码',
      accruedDepartmentName: '部门名称',
      storageNo: '仓库编码',
      storageName: '仓库名称',
      productNo: '物料编码',
      productDesc: '物料', //商品描述
      supplier: '供应商/客户名称',
      supplierName: '供应商/客户名称',
      contractNo: '采购/销售合同号',
      accruedType: '预提类型',
      docStatus: '单据状态',
      inboundNo: '业务入库单号',
      businessInboundBatchNo: '业务入库批次号',
      inboundQuantity: '业务入库数量/提单实发数量',
      accountingStatus: '入账状态',
      currencyCode: '币种',
      exchangeRate: '汇率',
      exchangeType: '汇率类型',
      exchangeDate: '汇率日期',
      accruedAmount: '预提金额原币',
      companyAccruedAmount: '预提金额本币',
      priceWithTax: '业务结算单价',
      priceWithoutTax: '不含税单价',
      purePrice: '业务结算价净值',
      amountWithTax: '业务结算价含税金额',
      taxAmount: '业务结算价税额',
      taxRate: '税率%',
      accountedDate: '入账日期',
      startAccountedDate: '入账日期从',
      endAccountedDate: '入账日期至',
      docDate: '制单日期',
      inboundNoLadingNo: '业务入库单号/销售提单号',
      businessInboundBatchNoLading: '业务入库批次号/提单行号',
    },
    withholdInfoAdd: {
      title: '创建预提单',
      column: {
        docNo: '单据编号',
        accruedCompanyCode: '公司代码',
        accruedCompanyName: '公司名称',
        accruedDepartmentCode: '部门代码',
        accruedDepartmentName: '部门名称',
        // contractNo:'采购/销售合同号',
        supplier: '供应商/客户',
        supplierName: '供应商/客户名称',
        contractNo: '采购合同号',
        contractDetailNo: '采购合同行号',
        accruedType: '预提类型',
        docStatus: '单据状态',
        inboundNo: '业务入库单号',
        businessInboundBatchNo: '业务入库批次号',
        inboundQuantity: '业务入库数量/提单实发数量',
        accountingStatus: '入账状态',
        currencyCode: '币种',
        currencyName: '币种名称',
        exchangeRate: '汇率',
        exchangeType: '汇率类型',
        exchangeDate: '汇率日期',
        accruedAmount: '预提原币总金额',
        accruedWithoutTaxAmount: '预提原币不含税金额',
        accruedTaxAmount: '预提原币税额',
        tax_code: '税码',
        taxRate: '税率%',
        companyAccruedAmount: '预提本币总金额',
        companyAccruedWithoutTaxAmount: '预提本币不含税金额',
        companyAccruedTaxAmount: '预提本币税额',
        priceWithTax: '业务结算单价',
        pricewithoutTax: '不含税单价',
        reversePostDate: '冲销入账日期',
        reverseStatus: '冲销入账状态',
        accountedDate: '入账日期',
        docDate: '制单日期',
        reverseReason: '冲销原因',
      },
      salesCloumn: {
        contractNo: '销售合同号',
        contractDetailNo: '销售合同行号',
        customerName: '客户名称',
        ladingNo: '提单号',
        ladingDetailNo: '提单行号',
        ladingQuantity: '提单数量',
        actualSendQuantity: '实发数量',
        businessChangingUnitPrice: '变动单价',
        businessLadingAmount: '提单金额',
        productNo: '物料编码',
        productDesc: '物料名称',
        storageNo: '仓库编码',
        storageName: '仓库名称',
      },
    },
    inboundLine: {
      title: '预提明细',
      table: {
        inboundQuantity: '入库数量',
      },
    },
    details: {
      title: '入库批次明细',
      ladingTitle: '销售提单明细',
    },
    placeholder: {
      docNoPlaceholder: '自动生成',
      accruedCompanyCodePlaceholder: '请选择公司',
      accruedDepartmentCodePlaceholder: '请选择部门',
      storageNamePlaceholder: '请选择仓库',
      productDescPlaceholder: '请输入物料',
      supplierPlaceholder: '请选择供应商/客户',
      contractNoPlaceholder: '请输入采购/销售合同号',
      accruedTypePlaceholder: '请选择预提类型',
      docStatusPlaceholder: '请选择单据状态',
      businessInboundBatchNoPlaceholder: '请输入业务入库批次号/提单行号',
      accountingStatusPlaceholder: '请选择入账状态',
      startAccountedDatePlaceholder: '请选择入账日期从',
      endAccountedDatePlaceholder: '请选择入账日期至',
      exchangeRatePlaceholder: '请输入汇率',
      inboundSalesQuantity: '业务入库数/提单实发数量',
    },
    btns: {
      add: '创建',
      edit: '编辑',
      save: '保存',
      submit: '提交审批',
      confirm: '确认',
      doWithdraw: '撤回',
      delete: '删除',
      generateCredentials: '生成凭证',
      writeOff: '冲销',
    },
    fundsInterests: {
      sumName: '合计',
    },
    warnInfo: {},
    message: {},
  },
};
